// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2afHW","ranges":"BmiRanges_ranges__1NrrJ"};